











import vue from 'vue';
import {Prop} from 'vue/types/options';

export default vue.extend({
  name: 'Icon',

  props: {
    name: {
      required: true,
      type: String as Prop<string>,
    },
  },

  computed: {
    isNova(): boolean {
      return !!this.name.match(/^nv-/);
    },
  },
});
